'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _components2 = require('components');

require('./AuthView.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AuthView: {
        displayName: 'AuthView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Auth/default/AuthView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AuthView = _wrapComponent('AuthView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(AuthView, _Component);

    function AuthView(props, context) {
        (0, _classCallCheck3.default)(this, AuthView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AuthView.__proto__ || (0, _getPrototypeOf2.default)(AuthView)).call(this, props, context));

        _this.refInput = function (input) {
            _this.inputLogin = input;
        };

        _this.showError = function () {
            var _this$props = _this.props,
                loginError = _this$props.loginError,
                loginErrorCode = _this$props.loginErrorCode,
                lang = _this$props.lang;


            if (loginError) {
                if (loginErrorCode === null || loginErrorCode === undefined) {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang['store.common.server_is_unavailable']
                    );
                } else {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang[loginError]
                    );
                }
            }

            return '';
        };

        _this.onClickRegistration = function (event) {
            event.preventDefault();
            if (_this.props.onClickRegistration) {
                _this.props.onClickRegistration(event);
            }
        };

        _this.onClickPassRecovery = function (event) {
            event.preventDefault();
            if (_this.props.onClickPassRecovery) {
                _this.props.onClickPassRecovery(event);
            }
        };

        _this.showCaptcha = function () {
            if (_this.props.showCaptcha) {
                return _react3.default.createElement(
                    _reactBootstrap.FormGroup,
                    null,
                    _this.props.showCaptcha()
                );
            }

            return '';
        };

        _this.handlePhoneChange = function (phone, country) {
            _this.props.changeField('login')(null, phone);
        };

        _this.inputLogin = null;

        _this.context.registerEvent('onEntering', function () {
            if (_this.inputLogin) {
                _reactDom2.default.findDOMNode(_this.inputLogin).focus();
            }
        });
        return _this;
    }

    (0, _createClass3.default)(AuthView, [{
        key: 'render',
        value: function render() {
            var lang = this.props.lang;

            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                _react3.default.createElement(
                    'main',
                    { id: 'authentication' },
                    _react3.default.createElement(
                        'div',
                        { className: 'container__' },
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-md-12' },
                                this.showError(),
                                _react3.default.createElement(
                                    'section',
                                    { id: 'auth-form', className: 'sign-in' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'bordered' },
                                        _react3.default.createElement(
                                            'form',
                                            { name: 'login', autoComplete: 'on', className: 'login-form', onSubmit: this.props.onSubmit },
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                { controlId: 'username', validationState: this.props.validateField('login') },
                                                _react3.default.createElement(
                                                    _reactBootstrap.ControlLabel,
                                                    null,
                                                    lang['store.login.phone_or_email']
                                                ),
                                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                                    type: 'text',
                                                    name: 'username',
                                                    controlId: 'login',
                                                    value: this.props.login,
                                                    onChange: this.props.changeField('login'),
                                                    placeholder: lang['store.login.email_or_phone_placeholder']
                                                })
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                { validationState: this.props.validateField('password'), controlId: 'password' },
                                                _react3.default.createElement(
                                                    _reactBootstrap.ControlLabel,
                                                    null,
                                                    lang['login.password']
                                                ),
                                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                                    type: 'password',
                                                    name: 'password',
                                                    controlId: 'password',
                                                    autoComplete: 'password',
                                                    placeholder: lang['login.password'],
                                                    value: this.props.password,
                                                    onChange: this.props.changeField('password') })
                                            ),
                                            this.showCaptcha(),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                null,
                                                _react3.default.createElement(
                                                    _reactBootstrap.Button,
                                                    {
                                                        type: 'submit',
                                                        bsStyle: 'primary',
                                                        className: 'form-control g-recaptcha',
                                                        disabled: this.props.disabledSubmit
                                                    },
                                                    lang['login.logIn']
                                                )
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                null,
                                                _react3.default.createElement(
                                                    'div',
                                                    { className: 'text-center to_page_passrecovery' },
                                                    _react3.default.createElement(
                                                        'a',
                                                        { onClick: this.onClickPassRecovery },
                                                        lang['login.forgotYourPassword']
                                                    )
                                                )
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                null,
                                                _react3.default.createElement(
                                                    'div',
                                                    { className: 'text-center to-page-registration' },
                                                    _react3.default.createElement(
                                                        _reactRouter.Link,
                                                        { to: '/registration', onClick: this.onClickRegistration },
                                                        lang['store.common.sign_up']
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return AuthView;
}(_react2.Component), _class.propTypes = {
    validateField: _react2.PropTypes.func.isRequired,
    showCaptcha: _react2.PropTypes.func,
    lang: _react2.PropTypes.object
}, _class.contextTypes = {
    registerEvent: _react2.PropTypes.func
}, _temp));

exports.default = AuthView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/default/AuthView.jsx
// module id = 1608
// module chunks = 0